<ng-container *ngIf="isReady">
    <div class="plan-info-details">
        <div class="plan-info-details-box">
          <span class="plan-info-details-box-title">Titular</span>
          <span class="plan-info-details-box-value" (click)="onTitlularChecked(!appliesForOwner)" [class.active]="appliesForOwner">
            <!-- <p-checkbox 
            (onChange)="onTitlularChecked($event)"
            [(ngModel)]="appliesForOwner"
            class="check-style"
            [binary]="true" 
            value="true" /> -->
          </span>
        </div>
        <div *ngIf="showDependents" >
        <div class="plan-info-details-box"  *ngFor="let item of dependents">
          <span class="plan-info-details-box-title">Añadir para dependiente {{item.text}}</span>
          <span (click)="onDependentSelected(item.id)" class="plan-info-details-box-value" [class.active]="item.selected">
          <!-- <p-checkbox 
          (onChange)="onDependentSelected(item.id)"
          [(ngModel)]="dependentSelected"
          class="check-style"
          [binary]="true" 
          [value]="item.id" 
          /> -->
        </span>
        </div>
    </div>
      </div>
    <!-- <div class="row">
        <div class="col-12">
            <div class="form-check pl-0">
                <p-checkbox 
                    (onChange)="onTitlularChecked($event)"
                    [(ngModel)]="appliesForOwner"
                    class="check-style"
                    [binary]="true" 
                    value="true" />
                <label class="form-check-label ml-2">Titular</label>
            </div>
        </div> 
    </div>
    <div class="row mt-3" *ngIf="showDependents">
        <div class="col-12">
            <div class="form-group">
                <label class="label-form-style">Dependientes</label>
                <select name="miselect" 
                        [(ngModel)]="dependentSelected" 
                        class="p-dropdown"
                        (change)="onDependentSelected($event)">
                    <option [value]="item.id" *ngFor="let item of dependents">{{item.text}}</option>
                </select>  
            </div>
        </div>
    </div> -->

</ng-container>

